export default instance => link => {
  if (link.lag && instance.config.auto_scheduling.enabled) {
    return 'finish_to_start';
  }
};
